import { render, staticRenderFns } from "./activityInfo.vue?vue&type=template&id=626f09d0&scoped=true"
import script from "./activityInfo.vue?vue&type=script&lang=js"
export * from "./activityInfo.vue?vue&type=script&lang=js"
import style0 from "./activityInfo.vue?vue&type=style&index=0&id=626f09d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f09d0",
  null
  
)

export default component.exports